import { Link, useLocation } from 'react-router'
import { useRef } from 'react';
import './Navbar.css'

import img_logo_1 from '../images/nuvlar-logo-1.png';
import img_logo_2 from '../images/nuvlar-logo-2.png';

function Navbar() {

    let location = useLocation();
    // let atHomePage = ['/', '/es', '/es/', '/en', '/en/'].includes(location.pathname);
    // let atHomePage = !['/contacto', '/legal'].includes(location.pathname);
    let atHomePage = !['/legal'].includes(location.pathname);

    let navbarTogglerRef = useRef();

    // Simular click en navbar toggle tras hacer click en un <Link> de react-router
    // Solo si se esta en modo movil
    const handleLinkClick = () => {
        if (window.innerWidth < 992) {
            if (navbarTogglerRef && navbarTogglerRef.current) {
                navbarTogglerRef.current.click();
            }
        }
    }

    return (
        <nav className={`navbar navbar-expand-lg ${atHomePage ? 'navbar-home' : ''}`}>
            <div className="navbar-brand d-flex align-items-center">
                {
                    atHomePage ?
                        <img alt='' src={img_logo_1} width='150' className="d-inline-block align-top" /> :
                        <img alt='' src={img_logo_2} width='150' className="d-inline-block align-top" />
                }
            </div>

            <button ref={navbarTogglerRef} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                {/* <span className="navbar-toggler-icon"></span> */}
                <i className="fa-solid fa-bars" style={{ fontSize: '1.2em' }}></i>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item active">
                        <Link to="/" className="nav-link" onClick={handleLinkClick}>INICIO</Link>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
                            PROYECTOS
                        </a>
                        <div className="dropdown-menu">
                            <a className="dropdown-item" target='_blank' rel="noreferrer" href="https://boletopolis.com">BOLETÓPOLIS <i className="fa fa-external-link" aria-hidden="true"></i></a>
                            <a className="dropdown-item" target='_blank' rel="noreferrer" href="https://www.consultopolis.com">CONSULTÓPOLIS <i className="fa fa-external-link" aria-hidden="true"></i></a>
                            {/* <Link to="/proyectos" className="dropdown-item">VER MÁS</Link> */}
                        </div>
                    </li>
                    {/* <li className="nav-item active">
                        <Link to="/contacto" className="nav-link" onClick={handleLinkClick}>CONTACTO</Link>
                    </li> */}
                </ul>
            </div>
        </nav>
    )
}

export default Navbar